import { supabase } from '../supabaseClient';
import { MIN_PASSWORD } from './businessLogin';

const MAX_PASSWORD = 72;

// ¿La sesión ya tiene una contraseña con la que entrar? Quien ingresó solo con Google todavía no tiene: para él es «crear», no «cambiar».
export const hasPasswordLogin = (user) => {
  const providers = Array.isArray(user?.app_metadata?.providers) ? user.app_metadata.providers : [user?.app_metadata?.provider];
  return providers.includes('email');
};

export function validateNewPassword({ current = '', next = '', confirm = '', needsCurrent = false }) {
  if (needsCurrent && !String(current)) return { ok: false, error: 'Escribe tu contraseña actual.' };
  if (String(next).length < MIN_PASSWORD) return { ok: false, error: `La contraseña nueva debe tener al menos ${MIN_PASSWORD} caracteres.` };
  if (String(next).length > MAX_PASSWORD) return { ok: false, error: `La contraseña no puede pasar de ${MAX_PASSWORD} caracteres.` };
  if (next !== confirm) return { ok: false, error: 'La confirmación no coincide con la contraseña nueva.' };
  if (needsCurrent && next === current) return { ok: false, error: 'La contraseña nueva debe ser distinta de la actual.' };
  return { ok: true };
}

export function passwordErrorMessage(error) {
  const text = `${error?.code || ''} ${error?.message || ''}`.toLowerCase();
  if (/reauth/.test(text)) return 'Por seguridad, cierra sesión, vuelve a entrar y repite el cambio.';
  if (/same_password|different from the old/.test(text)) return 'La contraseña nueva debe ser distinta de la actual.';
  if (/weak_password|weak/.test(text)) return 'Esa contraseña es muy fácil de adivinar. Usa una más larga o con letras y números.';
  if (/session|jwt|not authenticated|missing/.test(text)) return 'Tu sesión venció. Cierra sesión, vuelve a entrar y repite el cambio.';
  return 'No se pudo guardar la contraseña. Intenta de nuevo.';
}

// Crea o cambia la contraseña de quien tiene la sesión abierta. Con contraseña previa se comprueba la actual antes de cambiarla.
// Devuelve { ok, created } o { ok: false, error }.
export async function changeMyPassword({ email, current, next, confirm, needsCurrent }) {
  const check = validateNewPassword({ current, next, confirm, needsCurrent });
  if (!check.ok) return check;
  if (needsCurrent) {
    const { error } = await supabase.auth.signInWithPassword({ email, password: current });
    if (error) return { ok: false, error: 'La contraseña actual no es correcta.' };
  }
  const { error } = await supabase.auth.updateUser({ password: next });
  if (error) return { ok: false, error: passwordErrorMessage(error) };
  return { ok: true, created: !needsCurrent };
}
